import React, { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  Table,
  TableHead,
  Grid,
  Box,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addBreadcrumbAction, popBreadcrumbAction } from '../../../../actions/breadcrumbsAction';
import {
  updateMenuItemOptionAction,
  createMenuItemOptionAction,
} from '../../../../actions/menuItemOptionsAction';
import {
  cancelChoicesAction,
  saveInitialChoicesAction,
} from '../../../../actions/menuItemOptionChoicesAction';
import { addOptionsToProductAction } from '../../../../actions/productsAction';
import { TextButton } from '../Button/TextButton';
import OptionCreate from './OptionCreate';
import OptionEditDialog from './OptionEditDialog';
import useStyles from './OptionAddStyles';
import { dialogContexts } from '../../../../constants/constants';

/**
 * The dialog for dragging options onto a single menu item
 */
const OptionAddDialog = ({
  addOptionsToProductAction,
  openDialog,
  setOpenDialog,
  options,
  choices,
  defaultSelectedItems,
  addBreadcrumbAction,
  popBreadcrumbAction,
  productId,
}) => {
  const classes = useStyles();
  const [save, setSave] = useState(false);

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(false);

  const lastOption = options ? options?.localData.slice(-1)[0] : null;
  const lastOptionIndex = lastOption ? lastOption.optionIndex + 1 : 0;

  // Get choices for each option
  const [processedOptions, setProcessedOptions] = useState([]);
  useEffect(() => {
    setProcessedOptions(
      options?.localData.map((option) => {
        let choicesForOption = [];
        choices?.localData?.forEach((choice) => {
          if (option?.choiceIds?.includes(choice.objectId)) {
            choicesForOption = [...choicesForOption, choice?.choiceTitle];
          }
        });

        return {
          ...option,
          labelledChoices: choicesForOption,
        };
      }),
    );
  }, [options?.localData]);

  // breadcrumbs
  const [hasBreadcrumb, setHasBreadcrumb] = useState(false); // To ensure we don't pop some other breadcrumb if re-rendered while closed
  useEffect(() => {
    if (openDialog && !hasBreadcrumb) {
      addBreadcrumbAction(`Add option`);
      setHasBreadcrumb(true);
    } else if (!openDialog && hasBreadcrumb) {
      popBreadcrumbAction();
      setHasBreadcrumb(false);
    }
  }, [openDialog]);

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const validateForm = () => {
    const formError = false;

    return formError;
  };

  const submit = (event) => {
    event.preventDefault();

    const formError = validateForm();

    if (formError) {
      return;
    }

    // setProductOptions(selectedItems);

    addOptionsToProductAction(selectedItems);

    setSave(true);
    closeDialog();
  };

  const tableRef = useRef();
  const [selectedItems, setSelectedItems] = useState([]);
  const selectItem = (itemId, value) => {
    if (value === true && !selectedItems.includes(itemId)) {
      setSelectedItems([...selectedItems, itemId]);
    }

    // Remove item if deselected and in list
    if (value === false) {
      const updatedSelectedItems = selectedItems.filter((item) => item !== itemId);
      setSelectedItems(updatedSelectedItems);
    }
  };

  useEffect(() => {
    setSelectedItems(defaultSelectedItems);
  }, [defaultSelectedItems]);

  const selectAllItems = () => {
    setSelectedItems(options.localData.map((item) => item.id));
  };

  return (
    <Dialog
      open={openDialog}
      onClose={closeDialog}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      fullWidth
      maxWidth='lg'
      className={classes.dialog}
      onEnter={() => {
        setSave(false);
      }}
      onExited={() => {
        if (!save) {
          // Revert Options back to as they were on enter
          // cancelChoicesAction(menuItemId, optionId);
        }
      }}
    >
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={2}>
          <Grid item md={8} xs={12} className={classes.leftColumn}>
            <Box className={classes.modalTitle}>Options</Box>
            <Box className={classes.modalDescription}>Select from existing options</Box>
            {processedOptions.length === 0 ? (
              'No options to display. Please create some first.'
            ) : (
              <Table tableref={tableRef}>
                <TableHead>
                  <TableRow>
                    <TableCell> </TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Choices</TableCell>
                    <TableCell> </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {processedOptions.map((option, index) => (
                    <TableRow key={option.objectId} className={classes.row}>
                      <TableCell style={{ width: '20px' }}>
                        <Checkbox
                          style={{
                            color: selectedItems?.includes(option.objectId) ? '#E54439' : '#BDBDBD',
                          }}
                          checked={selectedItems.includes(option.objectId)}
                          onClick={(event) => event.stopPropagation()}
                          onChange={(event) => selectItem(option.objectId, event.target.checked)}
                        />
                      </TableCell>
                      <TableCell
                        onClick={() =>
                          selectItem(option.objectId, !selectedItems.includes(option.objectId))
                        }
                        style={{ fontSize: '18px' }}
                      >
                        {option.optionTitle}
                      </TableCell>
                      <TableCell
                        onClick={() =>
                          selectItem(option.objectId, !selectedItems.includes(option.objectId))
                        }
                        style={{ fontSize: '14px' }}
                      >
                        {option.optionDescription}
                      </TableCell>
                      <TableCell
                        onClick={() =>
                          selectItem(option.objectId, !selectedItems.includes(option.objectId))
                        }
                      >
                        <Box
                          style={{
                            fontSize: '14px',
                            color: '#2E2E2E',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '300px',
                          }}
                        >
                          {option?.labelledChoices?.join('; ')}
                        </Box>
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#FFF',
                          color: '#E54439',
                          width: '65px',
                          padding: 0,
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          setOpenEditDialog(true);
                          setSelectedOptionIndex(index);
                        }}
                      >
                        <TextButton>Edit</TextButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Grid>
          <Grid item md={4} xs={12} className={classes.rightColumn}>
            <Box className={classes.modalDescription}>Option doesn&apos;t exist?</Box>
            <OptionCreate
              buttonLabel='CREATE NEW OPTION'
              buttonType='secondary'
              productId={productId}
            />
          </Grid>
        </Grid>

        {selectedOptionIndex !== false && (
          <OptionEditDialog
            openDialog={openEditDialog}
            setOpenDialog={setOpenEditDialog}
            newOptionIndex={lastOptionIndex}
            option={options.localData.find((option, index) => index === selectedOptionIndex) || {}}
            dialogContext={dialogContexts.EDIT}
          />
        )}
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid #DCDCDB', minHeight: '50px' }}>
        <Box
          style={{ minHeight: '60px', margin: '0 20px', width: '100%' }}
          display='flex'
          justifyContent='space-between'
        >
          <Button onClick={closeDialog} color='default'>
            Cancel
          </Button>
          <Button onClick={submit} color='primary' type='submit' form='add-menu-item-option-form'>
            Add options
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  options: state.options,
  choices: state.choices,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      cancelChoicesAction,
      createMenuItemOptionAction,
      saveInitialChoicesAction,
      updateMenuItemOptionAction,
      addOptionsToProductAction,
      addBreadcrumbAction,
      popBreadcrumbAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(OptionAddDialog);
